/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ pending: NonNullable<unknown> }} Partner_Admin_Kpi_Pending_CountInputs */



/**
* | output |
* | --- |
* | "{pending} pending" |
*
* @param {Partner_Admin_Kpi_Pending_CountInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_kpi_pending_count = /** @type {((inputs: Partner_Admin_Kpi_Pending_CountInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Kpi_Pending_CountInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.pending} ausstehend`)
	return /** @type {LocalizedString} */ (`${i?.pending} pending`)
});